import { Textarea } from "@/components/ui/textarea";

export function CoverSection({ form, set }) {
  return (
    <div className="bg-white p-6 rounded-2xl border border-neutral-200/70 space-y-3">
      <h2 className="font-display font-semibold text-lg">Anything else?</h2>
      <Textarea rows={3} value={form.cover_note} onChange={(e) => set("cover_note", e.target.value)} placeholder="Anything else you'd like us to know…" data-testid="careers-cover"/>
    </div>
  );
}
